import { Environment, getEnvironment } from './get-environment';

// app ids taken from https://developers.facebook.com
export const FACEBOOK_APP_ID_FOR_SMART = {
  ProdApp: 2255636031317660,
  TestApp: 647456452727479,
  'TestApp-CI': 855695624786266,
};

// app ids for expert account
export const FACEBOOK_APP_ID_FOR_EXPERT = {
  ProdApp: 647456452727479,
  TestApp: 768575197290072,
  'TestApp-CI': 768575197290072,
};

/**
 * Gets the app id to use with the Facebook API.
 * Each app is restricted to requests from a specific domain name.
 * @param {string} domain - Current domain.
 * @param {boolean} isExpertAccount - Get different app ids by isExpertAccount flag.
 * @returns {Number} App id.
 */
export function getFacebookAppId(domain, isExpertAccount = false) {
  const environment = getEnvironment(domain);

  const FACEBOOK_APP_ID = isExpertAccount ? FACEBOOK_APP_ID_FOR_EXPERT : FACEBOOK_APP_ID_FOR_SMART;

  switch (environment) {
    case Environment.PROD:
    case Environment.BETAPROD:
    case Environment.TIP:
      return FACEBOOK_APP_ID.ProdApp;
    case Environment.SI:
    case Environment.BETASI:
      return FACEBOOK_APP_ID.TestApp;
    default:
      return FACEBOOK_APP_ID['TestApp-CI'];
  }
}
